
import { FormGroup, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class ValidationService {
  form: any;
  errors: any;
  messages: any;
  formArrayName: string;

  constructor() { }

  validate(form: FormGroup, errors: any, messages: any) {
    this.form = form;
    this.errors = errors;
    this.messages = messages;

    form
      .valueChanges
      .subscribe(data => this.onValueChanged(data));

    this.onValueChanged(); // (re)set validation messages now
  }

  onValueChanged(data?: any) { // helper method
    if (!this.form) { return; }
    const form = this.form;
    for (const field in this.errors) {
      if (field) {
        this.errors[field] = '';  // clear previous error message (if any)
        const control: FormControl = form.get(field);
        if (control  && control.dirty && !control.valid) {  // TODO: && control.value.length > 3
          const messages = this.messages[field];
          for (const key in control.errors) {
            if (key) {
              if (messages[key] !== '') {
                this.errors[field] += messages[key] + ' ';
              }
            }
          }
        }
      }
    }
  }

  validateArray(form: FormGroup, errors: any, messages: any, formArrayName: string) {
    this.form = form;
    this.errors = errors;
    this.messages = messages;
    this.formArrayName = formArrayName;

    form
      .valueChanges
      .subscribe(data => this.onValueChangedArray(data));

    this.onValueChangedArray(); // (re)set validation messages now
  }

  onValueChangedArray(data?: any) { // helper method
    if (!this.form) { return; }
    const form = this.form;

    for (let index = 0; index < form.get(this.formArrayName).length; index++) {
      let messages = this.messages[index];
      for (const field in this.errors[index]) {
        if (field) {
          this.errors[index][field] = '';  // clear previous error message (if any)
          const control: FormControl = form.get(this.formArrayName + '.' + index + '.' + field);
          if (control  && control.dirty && !control.valid) { // TODO: && control.value.length > 3
            const messageObject = messages[field];
            for (const key in control.errors) {
              if (key) {
                if (messages[key] === '') {
                  break;
                } else {
                  this.errors[index][field] += messages[key] + ' ';
                }
              }
            }
          }
        }
      }
    }
  }
}
